import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';

function Footer() {
    return (
        <footer className="footer">
        <p>Footer text here</p>
      </footer>
    );
}

export default Footer;